import { useFormContext, useWatch } from "react-hook-form";
import { RefinanceDebt } from "@/features/refinance/types";
import { isCommittedDebt } from "@/features/refinance/utils/debt-status";

/**
 * The debts left half-finished, which are saved before another is added. An
 * untouched suggestion from the credit check does not count, so the customer
 * can add their own debts without first filling in the suggested ones.
 */
export const useUnfinishedDebts = (items: { index: number }[]): number[] => {
	const { control } = useFormContext();
	const debts = useWatch({ control, name: "debts" }) as
		RefinanceDebt[] | undefined;

	return items
		.map(({ index }) => index)
		.filter((index) => {
			const debt = debts?.[index];
			if (!debt || debt.saved) return false;

			return !debt.isReported || isCommittedDebt(debt);
		});
};
